import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  resetPassword(attrs) {
    const url = apiRoutes.authPasswordPath();

    return FetchHelpers.post(url, attrs);
  },

  updatePassword(attrs, queryParams) {
    const url = apiRoutes.authPasswordPath();

    const headers = {
      'access-token': queryParams['access-token'],
      client: queryParams.client,
      uid: queryParams.uid,
      'Access-Control-Allow-Origin': '*',
    };

    return FetchHelpers.putWithHeaders(url, attrs, headers);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/auth/PasswordRepository.js